import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../../components/ReUsableComponents/CustomButton";
import {
  useGetUserDataByIdQuery,
  useProfileAssociationMutation,
  useProfileVerificationMutation,
} from "../../redux/API/ProfileSetup/profileSetupApi";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store/store";
import { useState } from "react";
import { BiCheckDouble } from "react-icons/bi";
import AuthButton from "./LoginButton";
import logoNew from "../../assets/Images/VerticalDarkLogo1.svg";
import sat from "../../assets/Images/SATprep1.svg";
import OnboardingBackground from "../../components/ReUsableComponents/OnboardingBackground";

const ProfileAssociation = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id1 = searchParams.get("id1") ?? "";
  const id2 = searchParams.get("id2") ?? "";
  const decodedId1 = atob(id1);
  const decodedId2 = atob(id2);
  const [loading, setLoading] = useState(false);

  const [profileAssociation] = useProfileAssociationMutation();
  const [profileVerification] = useProfileVerificationMutation();
  const path = window.location.pathname;
  const navigate = useNavigate();
  const isParent = !!path.includes("parentassociate");
  const isStudent = path.includes("studentassociate");

  useGetUserDataByIdQuery(decodedId1, {
    refetchOnMountOrArgChange: true,
    skip: !isParent && !isStudent,
  });
  useGetUserDataByIdQuery(decodedId2, {
    refetchOnMountOrArgChange: true,
    skip: !isParent && !isStudent,
  });
  const { parentName, studentName } = useSelector(
    (state: RootState) => state.root.profileSetupSlice
  );
  const onClickHandler = async () => {
    setLoading(true);
    try {
      const payload = {
        studentId: decodedId2,
        parentId: decodedId1,
      };
      const params = {
        userId: isParent ? decodedId1 : decodedId2,
        verificationType: "ASSOCIATION",
      };
      const res = await profileVerification(params).unwrap();
      if (res?.status === "success") {
        const res2 = await profileAssociation(payload).unwrap();
        if (res2?.status === "success") {
          navigate("/login");
          setLoading(false);
        }
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  return (
    <OnboardingBackground>
      <div className="mt-36 flex flex-col justify-center items-center px-10 w-[50%] bg-satPrepTransWhite p-9 rounded-[28px]">
          <div className="flex flex-col items-center w-full justify-between mx-auto gap-9">
          <img src={logoNew} className="w-[260px] h-[163px]" alt="FullMarks Logo" />
            <img src={sat} className="w-[211px] h-[68px]"  alt="SATprep Logo" />
          </div>
        <p className="mb-9 leading-[21.6px] text-center">
          <p className="font-bold text-satPrepAccent text-center text-[40px] font-pretendard cursor-pointer my-12">
            Account Link Request
          </p>
          {isParent ? (
            <div className="w-[440px]">
              Hi {parentName}! {studentName} has requested to be added to your
              account as a student. Do you accept?
            </div>
          ) : (
            <div className="w-[440px]">
              Hi {studentName}! {parentName}, has requested to be added to your
              account as a parent.If you accept, your existing associated parent
              will be replaced with F P.Do you accept?
            </div>
          )}
        </p>
        <div>
          <AuthButton
            text="Accept Request"
            icon={<BiCheckDouble className="w-6 h-6"/>}
            iconPosition="left"
            onClick={onClickHandler}
            loader={false}
            disabled={loading}
            className=""
          />
        </div>
      </div>
    </OnboardingBackground>
  );
};
export default ProfileAssociation;
